import {
  initPhotoSwipeFromDOM,
} from './utils-functions';
import createTemplate from './template';
import {
  DEFAULT_OPTIONS,
} from './default-options';

class Lightbox {
  constructor(element, options) {
    this.element = element;
    this._defaults = DEFAULT_OPTIONS;
    this.options = $.extend(true, {}, this._defaults, options);
    this.pswp = this.init();
  }

  init() {
    if (!$('[data-template="lightbox"]').length) {
      $('body').append(createTemplate(this.options));
    }

    return initPhotoSwipeFromDOM(this.element, this.options);
  }

  setPswp(pswp) {
    this.pswp = pswp;
  }

  getPswp(pswp) {
    this.pswp;
  }

  close() {
    if (this.pswp) {
      this.pswp.close();
    }
  }

  destroy() {
    if (this.pswp) {
      this.pswp.destroy();
    }
  }
}


export default Lightbox;
